import PropTypes from 'prop-types'

function Post({ title, url, publish_date, thumbnail, summary }) {
  return (
    <div className="flex-col md:flex">
      <a href={url} className="block" data-hover-image>
        <div className="overflow-hidden">
          <img src={thumbnail} alt={title} />
        </div>
      </a>

      <div className="flex-1 p-4 bg-white border border-t-0 md:py-6 md:px-8">
        <div className="text-gray-400">{publish_date}</div>

        <div>
          <a
            href={url}
            className="inline-block mt-1 font-medium leading-snug text-brand-blue hover:text-brand-green transition-colors"
          >
            {title}
          </a>
        </div>

        <div className="richtext" dangerouslySetInnerHTML={{ __html: summary }} />
      </div>
    </div>
  )
}

Post.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  publish_date: PropTypes.string,
  thumbnail: PropTypes.string,
  summary: PropTypes.string,
}

export default Post
